import { InitPageStrict } from "../../index";
import swal from "sweetalert";

class PickingShow {
  constructor() {
    $("#manage-note-btn").on("click", (e) => {
      e.preventDefault();
      $("#add-note-form").modal("show");
    });

    if (window.location.hash === "#notes") {
      $('a[href="#picking-notes-tab"]').tab("show");
    }

    $("#picking-items").on("click", ".delete-picking-item", (e) => {
      e.preventDefault();
      const link = e.currentTarget as HTMLElement;
      swal({
        title: "Are you sure?",
        text: link.dataset.deleteMessage,
        icon: "warning",
        closeOnClickOutside: false,
        buttons: {
          cancel: { text: "No", value: null, visible: true, className: "sn-btn sn-btn-sm sn-btn-silver", closeModal: true },
          confirm: { text: "Yes", value: true, visible: true, className: "sn-btn sn-btn-sm sn-btn-red", closeModal: true },
        },
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) $(link).next().trigger("click");
      });
    });

    $("#picking-items").on("click", ".inner-accordion-arrow-icon", (e) => {
      const icon = e.currentTarget as HTMLElement;
      if (icon.classList.contains("fa-chevron-down")) {
        icon.parentElement.setAttribute("data-remote", "true");
        icon.classList.remove("fa-chevron-down");
        icon.classList.add("fa-chevron-up");
      } else {
        e.preventDefault();
        icon.parentElement.removeAttribute("data-remote");
        icon.classList.remove("fa-chevron-up");
        icon.classList.add("fa-chevron-down");
      }
    });

    $("#PickingLogsTable").on("click", ".picking-eos-push-view", (e) => {
      e.preventDefault();
      const link = e.currentTarget as HTMLElement;
      $("#picking-eos-push-headers").text(this.pretty(link.dataset.headers));
      $("#picking-eos-push-body").text(this.pretty(link.dataset.body));
      $("#picking-eos-push-response").text(this.pretty(link.dataset.response));
      $("#picking-eos-push-dialog").modal("show");
    });
  }

  pretty(raw: string): string {
    try {
      return JSON.stringify(JSON.parse(raw), null, 2);
    } catch {
      return raw || "";
    }
  }
}

export function LoadPage() {
  InitPageStrict("pickings show", () => {
    if (document.getElementById("picking-details")) new PickingShow();
  });
}
